export default __webpack_public_path__ + "static/media/b2.38be15a9.svg";